import { TProjectEditorState } from 'shared/reducers';

export const selectConfig = (state: TProjectEditorState) => {
  return state.config;
};
